import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '@/modules/core/app/services/Lang';

export class PreferredPronouns extends Enum {
  key!: string;
  value!: string;

  static HE_HIM: PreferredPronouns = {
    key: 'he_him',
    get value(): string {
      return Lang.t('contact.preferred-pronouns-he-him');
    }
  };

  static SHE_HER: PreferredPronouns = {
    key: 'she_her',
    get value(): string {
      return Lang.t('contact.preferred-pronouns-she-her');
    }
  };

  static THEY_THEM: PreferredPronouns = {
    key: 'they_them',
    get value(): string {
      return Lang.t('contact.preferred-pronouns-they-them');
    }
  };
}
